import { Link } from "react-router-dom";
import { MapPin, Star, Waves } from "lucide-react";
import { fishBadge } from "@/lib/api";
import { FavoriteButton } from "@/components/FavoriteButton";

export default function SpotCard({ spot, onHover, active }) {
  return (
    <Link
      to={`/spots/${spot.id}`}
      data-testid={`spot-card-${spot.id}`}
      onMouseEnter={() => onHover && onHover(spot.id)}
      className={`group block rounded-2xl overflow-hidden bg-white border transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${
        active ? "border-amber-500 ring-2 ring-amber-500/30" : "border-emerald-900/10"
      }`}
    >
      <div className="relative h-40 overflow-hidden">
        <img
          src={spot.image}
          alt={spot.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-emerald-950/70 to-transparent" />
        <span className="absolute top-3 left-3 flex items-center gap-1 bg-white/90 backdrop-blur px-2.5 py-1 rounded-full text-xs font-semibold text-emerald-900">
          <Waves className="w-3.5 h-3.5 text-sky-600" /> {spot.water_type}
        </span>
        <div className="absolute top-3 right-3 flex items-center gap-2">
          <span className="flex items-center gap-1 bg-amber-500 text-white px-2 py-1 rounded-full text-xs font-bold">
            <Star className="w-3 h-3 fill-white" /> {spot.rating}
          </span>
          <FavoriteButton spotId={spot.id} />
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <h3 className="font-display font-bold text-lg text-white leading-tight">{spot.name}</h3>
          <p className="flex items-center gap-1 text-xs text-emerald-100/90">
            <MapPin className="w-3 h-3" /> {spot.department}
          </p>
        </div>
      </div>
      <div className="p-4">
        <div className="flex flex-wrap gap-1.5">
          {spot.fish.slice(0, 4).map((f) => (
            <span key={f} className={`text-[11px] font-semibold px-2 py-0.5 rounded-full ${fishBadge(f)}`}>
              {f}
            </span>
          ))}
        </div>
        <p className="text-sm text-slate-600 mt-3 line-clamp-2">{spot.description}</p>
      </div>
    </Link>
  );
}
